import { useTranslation } from 'react-i18next'
import { AnimatedPage, AnimatedPageHeader } from '@components/animated'
import { ChatSearch } from '../components/ChatSearch'
import { ListingModeToggle } from '../components/ListingModeToggle'

export function AiSearch() {
  const { t } = useTranslation('livability')
  return (
    <AnimatedPage className="app-chrome flex min-h-0 w-full flex-1 flex-col">
      <AnimatedPageHeader
        title={t('aiSearch.pageTitle')}
        description={t('aiSearch.pageDescription')}
      />
      <ListingModeToggle className="mb-5" />
      <ChatSearch />
    </AnimatedPage>
  )
}
